<template>
  <div class="help-screen" data-testid="help-screen">
    <!-- The bar of BzScreen (back at the left, the actions at the right, 64 high), with the name always in
         it: BzScreen's large title would take the top of a page that is not ours to scroll. -->
    <header class="help-bar">
      <div class="help-bar__inner">
        <BzButton kind="secondary" icon="arrow_back" :aria-label="$t('message.back')" data-testid="help-back" @click="goBack"/>
        <h1 class="help-bar__title">{{ $t('message.help') }}</h1>
        <BzButton kind="secondary" icon="refresh" :aria-label="$t('message.reload')" data-testid="help-reload" @click="reloadPage"/>
      </div>
    </header>
    <iframe class="help-frame" src="https://help.bronze.vision" :title="$t('message.help')" data-testid="help-iframe" allowfullscreen></iframe>
  </div>
</template>

<script>
import BzButton from '@/ui/components/BzButton.vue';

export default {
  name: 'HelpScreen',
  components: { BzButton },
  methods: {
    goBack() {
      this.$emit('go-back');
    },
    reloadPage() {
      window.location.reload();
    }
  }
};
</script>

<style scoped>
/* Help is on the design system (docs/sistema-diseno/README.md): the bar is BzScreen's, the page under it
   is help.bronze.vision's own, at the full width of the screen. */
.help-screen {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  background: var(--bz-bg);
  color: var(--bz-ink);
  font-family: var(--bz-font);
}

.help-bar {
  flex-shrink: 0;
  /* Under an iPad's status bar or a notch, never behind it (norm 10). */
  padding-top: env(safe-area-inset-top, 0px);
  border-bottom: 1px solid var(--bz-edge);
  background: var(--bz-bg);
}

.help-bar__inner {
  display: flex;
  align-items: center;
  gap: var(--bz-space-3);
  box-sizing: border-box;
  min-height: var(--bz-bar-height);
  padding: var(--bz-space-2) var(--bz-gutter);
}

.help-bar__title {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  font-family: var(--bz-font-display);
  font-size: var(--bz-text-lg);
  line-height: var(--bz-leading-lg);
  letter-spacing: var(--bz-tracking-lg);
  font-weight: var(--bz-weight-label);
  color: var(--bz-ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.help-frame {
  flex: 1 1 0;
  min-height: 0;
  width: 100%;
  border: 0;
}
</style>
